module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag21_1030AT.95ed5069.jpg";